import { ThemeOptions } from "@mui/material";
import { getInvertColor } from "utils/themeUtils";

export const formLabelOverrides: ThemeOptions["components"] = {
	MuiFormLabel: {
		styleOverrides: {
			root: ({ theme }) => ({
				"&.Mui-focused": {
					color:
						getInvertColor(theme.palette.primary.main) === "#3C4255"
							? "#3C4255"
							: theme.palette.primary.main,
				},
			}),
		},
	},
};
